import apiClient from '../lib/api-client';

export const pensionSchemeService = {
  // Select a specific pension scheme
  selectScheme: async (schemeData) => {
    try {
      const response = await apiClient.get('/member/select-scheme', {
        params: {
          member_number: schemeData.memberNumber || '',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error selecting pension scheme:', error);
      throw error;
    }
  },

  // Get beneficiaries for the currently selected scheme
  getBeneficiaries: async () => {
    try {
      const response = await apiClient.get('/beneficiaries');
      return response.data;
    } catch (error) {
      console.error('Error fetching beneficiaries:', error);
      throw error;
    }
  }
};
